/**
 * Narrows a column value to the up/down pair. Arrays (the Source column's channel
 * lists) and `null` are correctly treated as single values.
 */
export const isDualValue = (value) => typeof value === "object" && value !== null && !Array.isArray(value) && "up" in value && "down" in value;
